module.exports = __webpack_public_path__ + "img/18.03f649fb.svg";